import React from 'react';
import ReactDOM from 'react-dom';
import ContentTabs from "../../../ContentTabs/components/ContentTabs";

const elem = document.getElementById("corporateOss")

let data = [];

if (elem.dataset.showwhiteboard.trim().toLowerCase() === 'true') {
    data.push({
        backgroundUrl: "/images/solutions/corporate/Whiteboard_bus_770.jpg",
        iconUrl: "/images/solutions/WhiteBoard.svg",
        title: i18njs["Solutions.LinkWhiteboard"],
        mainText: i18njs["Solutions.WhiteboardMainTextCorporate"],
        buttonText: i18njs["Solutions.MoreInfo"],
        buttonUrl: "/products/interactive-flat-panel-displays/creative-board",
        tabIconUrl: "/images/solutions/WhiteBoard.svg"
    });
}

data.push({
    backgroundUrl: "/images/solutions/corporate/DS_bus_770.jpg",
    iconUrl: "/images/solutions/Display_Share.svg",
    title: i18njs["Solutions.DisplayShare"],
    subTitle: i18njs["Solutions.DisplayShareSubtitle"],
    mainText: i18njs["Solutions.DisplayShareMainTextCorporate"],
    buttonText: i18njs["Solutions.MoreInfo"],
    buttonUrl: "https://displayshare.optoma.com/",
    tabIconUrl: "/images/solutions/Display_Share.svg"
});

data.push({
    backgroundUrl: "/images/solutions/corporate/FM_bus_770.jpg",
    iconUrl: "/images/solutions/File_Manager.svg",
    title: i18njs["Solutions.FileManager"],
    mainText: i18njs["Solutions.FileManagerMainText"],
    buttonText: i18njs["Solutions.MoreInfo"],
    buttonUrl: "",
    tabIconUrl: "/images/solutions/File_Manager.svg"
});

ReactDOM.render(
    <ContentTabs data={data}></ContentTabs>,
    elem
);